import { api } from "@/modules/api";
import type { ApiSchema } from "@/modules/api";

export type Delegation = ApiSchema["CoreApi__TaskDelegationResponseSchema"];
export type VaultCredential = ApiSchema["CoreApi__VaultCredentialResponseSchema"];

function unwrap<T>({ data, error }: { data?: T; error?: unknown }, message: string): T {
  if (error || data === undefined) throw new Error(message);
  return data;
}

export async function getDelegationCapabilities() {
  return unwrap(
    await api.get("/v2/task-delegations/capabilities"),
    "Unable to check delegation availability."
  );
}
export async function getDelegations(taskId: string) {
  return unwrap(
    await api.get("/v2/task-delegations", {
      params: { query: { task_id: taskId } },
    }),
    "Unable to load delegation."
  );
}
export async function getVaultCredentials() {
  return unwrap(await api.get("/v2/task-delegations/credentials"), "Unable to load saved logins.");
}
export async function saveVaultCredential(
  body: ApiSchema["CoreApi__SaveVaultCredentialRequestSchema"]
) {
  return unwrap(
    await api.post("/v2/task-delegations/credentials", { body }),
    "Unable to save login. Use a public HTTPS website."
  );
}
export async function deleteVaultCredential(id: string) {
  const result = await api.delete("/v2/task-delegations/credentials/{credential_id}", {
    params: { path: { credential_id: id } },
  });
  if (result.error) throw new Error("Unable to remove login.");
}
export async function startDelegation(body: ApiSchema["CoreApi__StartDelegationRequestSchema"]) {
  return unwrap(
    await api.post("/v2/task-delegations", { body }),
    "Unable to start delegation. Retry to check whether it started."
  );
}
export async function approveDelegation(id: string, actionId: string) {
  return unwrap(
    await api.post("/v2/task-delegations/{delegation_id}/approve", {
      params: { path: { delegation_id: id } },
      body: { action_id: actionId },
    }),
    "This action may have changed. Refresh and review it again."
  );
}
export async function cancelDelegation(id: string) {
  return unwrap(
    await api.post("/v2/task-delegations/{delegation_id}/cancel", {
      params: { path: { delegation_id: id } },
    }),
    "Unable to confirm cancellation. Refresh to check its status."
  );
}

export async function notifyDelegation(id: string) {
  const result = await api.post("/v2/task-delegations/{delegation_id}/notify", {
    params: { path: { delegation_id: id } },
  });
  if (result.error) throw new Error("Unable to send this update to chat. Please retry.");
}
